import { ReactNode } from 'react';

import { Link } from '@argenta/react-ui';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';
import { HttpStatusCode } from 'axios';

import { ApiServiceError } from '../useApiService';

export const getErrorMessage = (error?: ApiServiceError): ReactNode => {
  if (!error) return undefined;

  if (error.errorCode === 'error.api.files.general') {
    return (
      <Trans
        id="vacancies.application.api.errors.file.general"
        values={{}}
        components={[<Link href={t({ id: 'vacancies.application.error.email' })} />]}
      />
    );
  }

  if (error.errorCode === 'error.vacancy.alreadyApplied') {
    return (
      <Trans
        id="vacancies.application.api.errors.alreadyApplied"
        values={{}}
        components={[<Link href={t({ id: 'vacancies.application.error.email' })} />]}
      />
    );
  }

  if (error.statusCode === HttpStatusCode.PayloadTooLarge) {
    return t({ id: 'vacancies.application.api.errors.entityTooLarge' });
  }

  return (
    <Trans
      id="vacancies.application.error"
      values={{}}
      components={[<Link href={t({ id: 'vacancies.application.error.email' })} />]}
    />
  );
};
